module.exports = __webpack_public_path__ + "static/media/transcribe-icon.2c51855e.png";